module.exports = __webpack_public_path__ + "static/media/30.25ce8cde.mp3";